// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreateUserReplyTemplateRequest,
  TCreateUserReplyTemplateModel,
  IMappers,
  TCreateUserReplyTemplateResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateUserReplyTemplatesListResponseSchema } from '../../entities/reply_templates/CreateUserReplyTemplatesListResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateUserReplyTemplateModel(
  parameters: TCreateUserReplyTemplateRequest,
): TCreateUserReplyTemplateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/create-user-reply-template/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateUserReplyTemplateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateUserReplyTemplateRequest;
}

export async function fetchCreateUserReplyTemplate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateUserReplyTemplateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateUserReplyTemplateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateUserReplyTemplateModel(parameters),
    config,
  )) as FetchResponse<TCreateUserReplyTemplateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateUserReplyTemplatesListResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateUserReplyTemplateResponse>;
}
